// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"2ebece45","23":"d375c1af"}[chunkId] + ".chunk.css";
};